import { CommunityFilter } from "~/types/CommunityTypes";

type Community = CommunityFilter;

export type CommunityState = {
    community: Community;

    setCommunity: (_user: Community) => void;

    clear: () => void;
};

export const communityStore = (
    set: (state: CommunityState) => void,
    get: () => CommunityState,
): CommunityState => ({
    community: undefined,
    setCommunity: (_community: Community) => {
        const currentState = get();

        if (
            JSON.stringify(currentState.community) !==
            JSON.stringify(_community)
        ) {
            set({ ...currentState, community: _community });
        }
    },
    clear: () => {
        set({
            community: undefined,
            setCommunity: (_user: Community) => {},
            clear: () => {},
        });
    },
});
